import React, { useState, useEffect } from 'react';
import { TextField, Button, Box, Card, CardContent, Stack, Autocomplete, Grid } from '@mui/material';
import * as XLSX from 'xlsx';
import { saveAs } from 'file-saver';
import { BASE_URL } from '../../App';
import Swal from 'sweetalert2';
import axios from 'axios';

const Approved_Brv_Details = () => {
    const [dateFrom, setDateFrom] = useState(null);
    const [dateTo, setDateTo] = useState(null);
    const [branch, setBranch] = useState('ALL');
    const [dealer, setDealer] = useState('ALL');
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);
    const [tableData, setTableData] = useState([]);
    const [showTable, setShowTable] = useState(false);
    const [showDownloadButton, setShowDownloadButton] = useState(false);
    const [branchData, setBranchData] = useState([]);
    const [dealerData, setDealerData] = useState([]);
//BRANCH_CODE
const login_id = localStorage.getItem("LOGIN_ID");
const BRANCH_CODE = localStorage.getItem("BRANCH_CODE");
    useEffect(() => {
        const fetchBranchData = async () => {
            setLoading(true);
            try {
                const response = await axios.post(BASE_URL + '/getbranchdetails', {
                    login_id: login_id,
                    branch_code: BRANCH_CODE,
                });

                if (response.data && response.data.branchlist) {
                    setBranchData(response.data.branchlist);
                } else {
                    setError('No branches found.');
                }
            } catch (error) {
                setError('Failed to fetch branches.');
            } finally {
                setLoading(false);
            }
        };

        fetchBranchData();
    }, []);
    // const handleBranchChange = (event, value) => {
    //     setBranch(value ? value.BRANCH_CODE : 'ALL');
    //   };
      
 
      

    const fetchDealerData = async (selectedBranch) => {
        if (!selectedBranch) return;

        try {
            const response = await axios.post(BASE_URL + '/getdealerdetails', {
                branch: selectedBranch,
                dealer_condition: selectedBranch,
            });

            if (response.data && response.data.dealerList) {
                setDealerData(response.data.dealerList);
            } else {
                setDealerData([]);
                setError('No dealers found for this branch.');
            }
        } catch (error) {
            setError('Failed to fetch dealers.');
        }
    };

    useEffect(() => {
        if (branch) {
            fetchDealerData(branch);
        }
    }, [branch]);


    const formatDate = (date) => {
        if (!date) return '';
        const d = new Date(date);
        const day = d.getDate().toString().padStart(2, '0');
        const month = (d.getMonth() + 1).toString().padStart(2, '0');
        const year = d.getFullYear();
        return `${day}-${month}-${year}`;
    };


    const handleDateChange = (setter) => (event) => {
        const date = event.target.value;
        setter(date);
    };

    const handleViewData = async () => {
        console.log('Date From:', dateFrom);
        console.log('Date To:', dateTo);
        console.log('Branch:', branch);
        console.log('Dealer:', dealer);

        if (dateFrom && dateTo) {
            const diffInTime = new Date(dateTo).getTime() - new Date(dateFrom).getTime();
            const diffInDays = diffInTime / (1000 * 3600 * 24);

            if (diffInDays > 31) {
                //setError('The date range cannot exceed 31 days.');
                Swal.fire('info', 'The date range cannot exceed 31 days.', 'error');
                return;
            }
        }

        setLoading(true);
        setError(null);
        setShowTable(true);

        Swal.fire({
            title: 'Loading...',
            text: 'Fetching data...',
            allowOutsideClick: false,
            didOpen: () => {
                Swal.showLoading();
            },
        });

        try {
            const requestData = {
                login_id: 'ADMIN',
                branch_code: branch === '' ? 'ALL' : branch,
                dealer_code: dealer === '' ? 'ALL' : dealer,
                from_date: dateFrom ? dateFrom : '',
                to_date: dateTo ? dateTo : '',
            };

            console.log('Request Data:', requestData);

            const response = await axios.post(BASE_URL + '/getapprovedbrvdetails', requestData, {
                headers: {
                    'Content-Type': 'application/json'
                }
            });

            console.log('Response Data:', response.data);

            if (response.status === 200) {
                if (response.data && response.data.data) {
                    setTableData(response.data.data);
                    setShowDownloadButton(true);
                } else {
                    setTableData([]);
                    setError('No data found for the selected criteria.');
                }
            } else {
                setError('Unexpected response from the server.');
                console.error('Error Response:', response);
                Swal.fire('Error', `Unexpected response: ${response.statusText}`, 'error');
            }
        } catch (error) {
            console.error('Error fetching data:', error);
            setError('Failed to fetch data.');
            Swal.fire('Error', 'An error occurred while fetching data.', 'error');
        } finally {
            setLoading(false);
            Swal.close();
        }
    };

    const handleDownloadExcel = () => {
 
             if (tableData.length === 0) {
        Swal.fire({
            icon: "info",
            text: 'No Data Available For export!'
        });
        return;
    } 
         Swal.fire({
             title: 'Are you sure?',
             text: 'You are about to download the Excel file. Do you want to continue?',
             icon: 'warning',
             showCancelButton: true,
             confirmButtonText: 'Yes, Download',
             cancelButtonText: 'No, Cancel',
         }).then((result) => {
       if (result.isConfirmed) {
                const ws = XLSX.utils.json_to_sheet(tableData);
                 const wb = XLSX.utils.book_new();
                 XLSX.utils.book_append_sheet(wb, ws, 'Approved BRV Details');
                 const excelFile = XLSX.write(wb, { bookType: 'xlsx', type: 'array' });

                 saveAs(new Blob([excelFile]), 'approved_brv_details.xlsx');
               Swal.fire('Downloading...', 'Your file is being downloaded.', 'success');
             }
        });
     };
    //     const handleDownloadExcel = () => {
    //     if (tableData.length === 0) {
    //         Swal.fire({
    //             icon: "info",
    //             text: 'No Data Available For export!'
    //         });
    //         return;
    //     }
    //     Swal.fire({
    //         title: 'Are you sure?',
    //         text: 'Do you want to download the Excel file?',
    //         icon: 'question',
    //         showCancelButton: true,
    //         confirmButtonText: 'Yes, download it!',
    //         cancelButtonText: 'No, cancel!',
    //         reverseButtons: true
    //     }).then((result) => {
    //         if (result.isConfirmed) {
    //             setOpen(true);
    
    //             const ExcelJS = require('exceljs');
    //             const workbook = new ExcelJS.Workbook();
    //             const worksheet = workbook.addWorksheet('Sheet1');
    
    //             // Define columns based on tableData structure
    //             worksheet.columns = Object.keys(tableData[0]).map(key => ({ header: key, key }));
    
    //             // Add data to the worksheet
    //             tableData.forEach(data => worksheet.addRow(data));
    
    //             // Set header row styles (e.g., background color)
    //             const headerRow = worksheet.getRow(1);
    //             headerRow.eachCell((cell) => {
    //                 cell.fill = {
    //                     type: 'pattern',
    //                     pattern: 'solid',
    //                     fgColor: { argb: 'bf43bb' } // Red color as an example; customize as needed
    //                 };
    //             });
    
    //             // Autofilter for all columns
    //             worksheet.autoFilter = {
    //                 from: 'A1',
    //                 to: 'I1'
    //             };
    
    //             // Generate Excel file and initiate download
    //             setTimeout(() => {
    //                 workbook.xlsx.writeBuffer().then((buffer) => {
    //                     const blob = new Blob([buffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
    //                     const link = document.createElement('a');
    //                     link.href = window.URL.createObjectURL(blob);
    //                     link.download = 'Attendance_Extraction_Report.xlsx';
    //                     link.click();
    //                     //setOpen(false);
    //                 });
    //             }, 1000);
    //         }
    //     });
    // };

    return (
        <Box
            sx={{
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'flex-start',
                minHeight: '100vh',
                backgroundColor: '#f4f4f4',
                paddingTop: 3,
                paddingLeft: 3,
            }}
        >
            <Card sx={{ width: '100%', maxWidth: '1800px' }}>
                <CardContent>
                    <Box sx={{ width: '100%' }}>
                        <Grid container spacing={3}>
                      
                            <Grid item xs={6} md={3}>
                                <Autocomplete
                                    disablePortal
                                    options={[{ BRANCH_CODE: 'ALL', BRANCH_NAME: 'All' }, ...branchData]}
                                    getOptionLabel={(option) =>
                                        option.BRANCH_CODE === 'ALL'
                                            ? 'ALL'
                                            : `${option.BRANCH_CODE} - ${option.BRANCH_NAME}`
                                    }
                                    renderInput={(params) => <TextField {...params} label="Branch" />}
                                     onChange={(event, value) => setBranch(value ? value.BRANCH_CODE : 'ALL')}
                                    //onChange={handleBranchChange}
                                    sx={{ width: '100%' }}
                                />
                            </Grid>

                            <Grid item xs={6} md={3}>
                                <Autocomplete
                                    disablePortal
                                    options={[{ dealer_code: 'ALL', dealername: 'All' }, ...dealerData]}
                                    getOptionLabel={(option) =>
                                        option.dealer_code === 'ALL'
                                            ? 'ALL'
                                            : `${option.dealer_code} - ${option.dealername}`
                                    }
                                    renderInput={(params) => <TextField {...params} label="Dealer" />}
                                    onChange={(event, value) => setDealer(value ? value.dealer_code : 'ALL')}
                                    sx={{ width: '100%' }}
                                />
                            </Grid>

                            <Grid item xs={6} md={3}>
                                <TextField
                                    label="From Date"
                                    type="date"
                                    value={dateFrom || ''}
                                    onChange={handleDateChange(setDateFrom)}
                                    InputLabelProps={{ shrink: true }}
                                    fullWidth
                                    sx={{ width: '100%' }}
                                />
                            </Grid>

                            <Grid item xs={6} md={3}>
                                <TextField
                                    label="Date To"
                                    type="date"
                                    value={dateTo || ''}
                                    onChange={handleDateChange(setDateTo)}
                                    InputLabelProps={{ shrink: true }}
                                    fullWidth
                                    sx={{ width: '100%' }}
                                />
                            </Grid>

                            {/* Second Row: Buttons */}
                            <Grid item xs={6} md={3}>
                                <Stack direction="row" spacing={2}>
                                    <Button
                                        variant="contained"
                                        color="primary"
                                        onClick={handleViewData}
                                        disabled={loading || !dateFrom || !dateTo || branch === '' || dealer === ''}
                                        sx={{ width: '100%' }}
                                    >
                                        {loading ? 'Loading...' : 'View'}
                                    </Button>
                                </Stack>
                            </Grid>

                            {showDownloadButton && (
                                <Grid item xs={6} md={3}>
                                    <Stack direction="row" spacing={2}>
                                        <Button
                                            variant="contained"
                                            onClick={handleDownloadExcel}
                                            sx={{
                                                width: '100%',
                                                backgroundColor: 'green',
                                                color: 'white',
                                                '&:hover': {
                                                    backgroundColor: 'darkgreen',
                                                },
                                            }}
                                        >
                                            Download Excel
                                        </Button>
                                    </Stack>
                                </Grid>
                            )}
                        </Grid>

                    </Box>
                </CardContent>
            </Card>

            {error && (
                <Box sx={{ mt: 2, color: 'red' }}>
                    <p>{error}</p>
                </Box>
            )}

            {showTable && !loading && (
                <Box sx={{ mt: 3, width: '100%', maxWidth: '1800px' }}>
                    <div style={{ overflowX: 'auto', maxHeight: '680px', overflowY: 'auto' }}>
                        <table
                            border="1"
                            cellPadding="8"
                            cellSpacing="0"
                            style={{
                                width: '100%',
                                borderCollapse: 'collapse',
                                tableLayout: 'auto',
                            }}
                        >
                            <thead style={{ position: 'sticky', top: 0, backgroundColor: '#1976d2', color: 'white', zIndex: 1 }}>
                                <tr>
                                    <th style={{ width: '12%', padding: '8px', textAlign: 'center' }}>Plant Code</th>
                                    <th style={{ width: '12%', padding: '8px', textAlign: 'center' }}>Plant Name</th>
                                    <th style={{ width: '12%', padding: '8px', textAlign: 'center' }}>Customer Code</th>
                                    <th style={{ width: '12%', padding: '8px', textAlign: 'center' }}>Customer Name</th>
                                    <th style={{ width: '12%', padding: '8px', textAlign: 'center' }}>Receipt Document No</th>
                                    <th style={{ width: '12%', padding: '8px', textAlign: 'center' }}>Receipt Date</th>
                                    <th style={{ width: '12%', padding: '8px', textAlign: 'center' }}>UTR No</th>
                                    <th style={{ width: '12%', padding: '8px', textAlign: 'Right' }}>Amount</th>
                                </tr>
                            </thead>
                            <tbody>
                                {tableData.length > 0 ? (
                                    tableData.map((row, index) => (
                                        <tr key={index}>
                                            <td style={{ textAlign: 'center' }}>{row.Plant_Code}</td>
                                            <td style={{ textAlign: 'center' }}>{row.Plant_name}</td>
                                            <td style={{ textAlign: 'center' }}>{row.Customer_code}</td>
                                            <td style={{ textAlign: 'center' }}>{row.Customer_name}</td>
                                            <td style={{ textAlign: 'center' }}>{row.Receipt_Document_No}</td>
                                            <td style={{ textAlign: 'center' }}>{row.Receipt_Date}</td>
                                            <td style={{ textAlign: 'center' }}>{row.UTR_No}</td>
                                            <td style={{ textAlign: 'right' }}>
                                                {row.Amount != null ? parseFloat(row.Amount).toFixed(2) : 'N/A'}
                                            </td>
                                        </tr>
                                    ))
                                ) : (
                                    <tr>
                                        <td colSpan="8">No data available</td>
                                    </tr>
                                )}
                            </tbody>
                        </table>
                    </div>
                </Box>
            )}
        </Box>
    );
};

export default Approved_Brv_Details;



























